import { render, staticRenderFns } from "./AffiliateSettings.vue?vue&type=template&id=cfdfcbe0"
import script from "./AffiliateSettings.vue?vue&type=script&lang=js"
export * from "./AffiliateSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/devstark/spreadsimple/spreadsimple-app/main-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cfdfcbe0')) {
      api.createRecord('cfdfcbe0', component.options)
    } else {
      api.reload('cfdfcbe0', component.options)
    }
    module.hot.accept("./AffiliateSettings.vue?vue&type=template&id=cfdfcbe0", function () {
      api.rerender('cfdfcbe0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/account-page/affiliate-settings/AffiliateSettings.vue"
export default component.exports